import { Chip } from '@material-ui/core'
import {
  components,
  constants,
  useTranslation,
  useServices
} from 'cng-web-lib'

import React, { useEffect, useRef, useState } from 'react'
import ArrivalCertApiUrls from '../../../apiUrls/ArrivalCertApiUrls'
import ArrivalCertKeys from '../../../constants/locale/key/ArrivalCert'
import Namespace from '../../../constants/locale/Namespace'
import { getStatusMetadata } from '../../../common/NACommon'
import moment from 'moment-timezone'
import { FileForUserGetPartyId, FileForUserGetUserDetails } from '../../../common/FileForUserCommon'
import pathMap from '../../../paths/pathMap'
import { generatePath } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AlertDialog from '../../../components/aciacehighway/AlertDialog'
import _ from 'lodash'
import Table from '../../../components/aciacehighway/Table'
import ArrivalCertUploadDialog from './ArrivalCertUploadDialog'

const {
  table: { useFetchCodeMaintenanceLookup }
} = components

const {
  filter: { BETWEEN, EQUAL, IN, LIKE },
  CodeMaintenanceType
} = constants

function TablePage(props) {
  function DisableSubmitButton(rows) {
    let shouldDisable = false
    rows.forEach((rowData) => {
      if (rowData.status === '1008') {
        shouldDisable = true
      }
    })
    return shouldDisable
  }

  function DisableSubmitAsModifyButton(rows) {
    let shouldDisable = false
    rows.forEach((rowData) => {
      if ((rowData.status !== "2" || rowData.errorDesc !== "EDIFACT conformance check error")) {
        shouldDisable = true
      }
    })
    return shouldDisable
  }

  const DisableDeleteButtonByStatus = (rowData) => {
    var isDisable = false
    for (let record in rowData) {
      var row = rowData[record]
      if (row.status !== "1005") {
        isDisable = true
        break
      }
    }
    return isDisable
  }

  const { history, showNotification } = props

  const [lookups, setLookups] = useState(null)
  const [alertDialog, setAlertDialog] = useState({ open: false, arrivalCerts: [] })
  const { translate } = useTranslation(Namespace.ARRIVAL_CERT)
  const translatedTextsObject = makeTranslatedTextsObject()
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const tableRef = useRef()
  const { createRecord, deleteRecord } = useServices()
  const [uploadCSVDialog, setUploadCSVDialog] = useState(false)
  const { securedSendRequest } = useServices()

  const [statusLookup, setStatusLookup] = useState([]);
  useEffect(() => {
    Promise.all([fetchCodeMaintenanceLookup(constants.CodeMaintenanceType.CODE_MASTER,
      undefined, [{ field: 'codeType', operator: 'equal', value: 'ACIHWY_RNS_STATUS' }],
      undefined, 'code')])
      .then(([e]) => setStatusLookup(e))
  }, []);

  useEffect(() => {
    Promise.all([
      fetchCodeMaintenanceLookup(CodeMaintenanceType.CODE_MASTER, undefined, [
        { field: 'codeType', operator: EQUAL, value: 'ACI_HW_IBA_MSG_FUNC' }
      ])
    ]).then(([messageFunction]) => {
      setLookups({ messageFunction })
    })
  }, [])

  function makeTranslatedTextsObject() {
    let ccn = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.CCN
    )
    let destinationOfficeCode = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.DESTINATION_OFFICE_CODE
    )
    let messageFunction = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.MESSAGE_FUNCTION
    )
    let status = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.STATUS
    )
    let createdDate = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.CREATED_DATE
    )
    let cloneButton = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.CLONE_BUTTON
    )
    let deleteButton = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.DELETE_BUTTON
    )
    let deleteMultipleRecords = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.DELETE_MULTIPLE_RECORDS
    )
    let submitMultipleRecords = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.SUBMIT_MULTIPLE_RECORDS
    )
    let error = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.ERROR
    )
    let submitAsModify = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.SUBMIT_AS_MODIFY
    )
    let bolNumber = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.BOL_NUMBER
    )
    let editButton = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.EDIT_BUTTON
    )
    let editTooltipDisabled = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.EDIT_TOOLTIP_DISABLED
    )
    let uploadButton = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.UPLOAD_BUTTON
    )
    let createButton = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.CREATE_BUTTON
    )
    let submitAllButton = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.SUBMIT_ALL_BUTTON
    )
    let submitAsModifyButton = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.SUBMIT_AS_MODIFY_BUTTON
    )
    let deleteConfirmMessage = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.DELETE_CONFIRM_MESSAGE
    )
    let deleteConfirmYes = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.DELETE_CONFIRM_YES
    )
    let deleteConfirmNo = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.DELETE_CONFIRM_NO
    )
    let deleteSuccessMessage = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.DELETE_SUCCESS_MESSAGE
    )
    let cloneErrorMessage = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.CLONE_ERROR_MESSAGE
    )
    let submitSuccessMessage = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.SUBMIT_SUCCESS_MESSAGE
    )
    let submitAllFailedMessage = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.SUBMIT_ALL_FAILED_MESSAGE
    )
    let filterMsgFuncAdd = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_MSG_FUNC_ADD
    )
    let filterMsgFuncCancel = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_MSG_FUNC_CANCEL
    )
    let filterMsgFuncModify = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_MSG_FUNC_MODIFY
    )
    let filterStatusDraft = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_STATUS_DRAFT
    )
    let filterStatusSent = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_STATUS_SENT
    )
    let filterStatusGoodsReleased = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_STATUS_GOODS_RELEASED
    )
    let filterStatusDeclarationAcceptedAwaitingArrival = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_STATUS_DECLARATION_ACCEPTED_AWAITING_ARRIVAL
    )
    let filterStatusDeclarationAcceptedAwaitingCustoms = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_STATUS_DECLARATION_ACCEPTED_AWAITING_CUSTOMS
    )
    let filterStatusMessageContentRejected = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_STATUS_MESSAGE_CONTENT_REJECTED
    )
    let filterStatusMessageContentAccepted = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_STATUS_MESSAGE_CONTENT_ACCEPTED
    )
    let filterStatusGoodsRequiredExamination = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_STATUS_GOODS_REQUIRED_EXAMINATION
    )
    let filterStatusGoodsMayMoveDetain = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_STATUS_GOODS_MAY_MOVE_DETAIN
    )
    let filterStatusErrorMessage = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_STATUS_ERROR_MESSAGE
    )
    let filterStatusAuthorisedDeliverCsa = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_STATUS_AUTHORISED_DELIVER_CSA
    )
    let filterErrorDescEdifact = translate(
      Namespace.ARRIVAL_CERT,
      ArrivalCertKeys.FILTER_ERROR_DESC_EDIFACT
    )
    return {
      messageFunction,
      ccn,
      destinationOfficeCode,
      status,
      createdDate,
      cloneButton,
      deleteButton,
      deleteMultipleRecords,
      submitMultipleRecords,
      error,
      submitAsModify,
      bolNumber,
      editButton,
      editTooltipDisabled,
      uploadButton,
      createButton,
      submitAllButton,
      submitAsModifyButton,
      deleteConfirmMessage,
      deleteConfirmYes,
      deleteConfirmNo,
      deleteSuccessMessage,
      cloneErrorMessage,
      submitSuccessMessage,
      submitAllFailedMessage,
      filterMsgFuncAdd,
      filterMsgFuncCancel,
      filterMsgFuncModify,
      filterStatusDraft,
      filterStatusSent,
      filterStatusGoodsReleased,
      filterStatusDeclarationAcceptedAwaitingArrival,
      filterStatusDeclarationAcceptedAwaitingCustoms,
      filterStatusMessageContentRejected,
      filterStatusMessageContentAccepted,
      filterStatusGoodsRequiredExamination,
      filterStatusGoodsMayMoveDetain,
      filterStatusErrorMessage,
      filterStatusAuthorisedDeliverCsa,
      filterErrorDescEdifact
    }
  }

  function getLookupValue(name, value) {
    if (!lookups) return value

    return lookups[name] && lookups[name][value] ? lookups[name][value] : value
  }

  const columns = [
    // { field: "id", title: "ID" },
    {
      field: "messageFunction",
      title: translatedTextsObject.messageFunction,
      render: (rowData) => getLookupValue('messageFunction', rowData.messageFunction)
    },
    {
      field: "ccn",
      title: translatedTextsObject.ccn,
    },
    {
      field: "destinationOfficeCode",
      title: translatedTextsObject.destinationOfficeCode,
    },
    {
      field: "status",
      title: translatedTextsObject.status,
      render: (data) => {
        const status = getStatusMetadata(data.status)

        return (
          <Chip
            label={getStatusDescription(data.status)}
            size='small'
            style={{
              backgroundColor: status.color,
              color: status.contrastColor,
              fontSize: 12
            }}
          />
        )
      },
    },
    {
      field: "bolNumber",
      title: translatedTextsObject.bolNumber,
    },    
    {
      field: "createdDate",
      title: translatedTextsObject.createdDate,
      render: (rowData) =>
        rowData.createdDate && moment(rowData.createdDate).tz("Canada/Eastern").format('DD/MM/YYYY HH:mm:ss'),
    },
    {
      field: "errorDesc",
      title: translatedTextsObject.error,
    },
  ]

  const filters = [
    {
      label: translatedTextsObject.messageFunction,
      type: 'checkbox',
      name: 'messageFunction',
      operatorType: IN,
      options: [
        {
          label: translatedTextsObject.filterMsgFuncAdd,
          value: 'ADD',
          filterValue: {
            value: '9'
          }
        },
        {
          label: translatedTextsObject.filterMsgFuncCancel,
          value: 'CANCEL',
          filterValue: {
            value: '1'
          }
        },
        {
          label: translatedTextsObject.filterMsgFuncModify,
          value: 'MODIFY',
          filterValue: {
            value: '4'
          }
        }
      ]
    },
    {
      label: translatedTextsObject.ccn,
      type: 'textfield',
      name: 'ccn',
      operatorType: LIKE
    },
    {
      label: translatedTextsObject.destinationOfficeCode,
      type: 'textfield',
      name: 'destinationOfficeCode',
      operatorType: LIKE
    },
    {
      label: translatedTextsObject.status,
      type: 'checkbox',
      name: 'status',
      operatorType: IN,
      options: [
        {
          label: translatedTextsObject.filterStatusDraft,
          value: 'DRAFT',
          filterValue: {
            value: '1005'
          }
        },
        {
          label: translatedTextsObject.filterStatusSent,
          value: 'SENT',
          filterValue: {
            value: '1008'
          }
        },
        {
          label: translatedTextsObject.filterStatusGoodsReleased,
          value: 'GOODS_RELEASED',
          filterValue: {
            value: '4'
          }
        },
        {
          label: translatedTextsObject.filterStatusDeclarationAcceptedAwaitingArrival,
          value: 'DECLARATION_ACCEPTED_AWAITING_ARRIVAL_OF_GOODS',
          filterValue: {
            value: '9'
          }
        },
        {
          label: translatedTextsObject.filterStatusDeclarationAcceptedAwaitingCustoms,
          value: 'DECLARATION_ACCEPTED_AWAITING_CUSTOMS_PROCESSING',
          filterValue: {
            value: '34'
          }
        },
        {
          label: translatedTextsObject.filterStatusMessageContentRejected,
          value: 'MESSAGE_CONTENT_REJECTED_WITH_COMMENT',
          filterValue: {
            value: '2'
          }
        },
        {
          label: translatedTextsObject.filterStatusMessageContentAccepted,
          value: 'MESSAGE_CONTENT_ACCEPTED',
          filterValue: {
            value: '1'
          }
        },
        {
          label: translatedTextsObject.filterStatusGoodsRequiredExamination,
          value: 'GOODS_REQUIRED_FOR_EXAMINATION_REFERRED',
          filterValue: {
            value: '5'
          }
        },
        {
          label: translatedTextsObject.filterStatusGoodsMayMoveDetain,
          value: 'GOODS_MAY_MOVE_DETAIN_AT_DESTINATION_CFIA',
          filterValue: {
            value: '8'
          }
        },
        {
          label: translatedTextsObject.filterStatusErrorMessage,
          value: 'ERROR_MESSAGE',
          filterValue: {
            value: '14'
          }
        },
        {
          label: translatedTextsObject.filterStatusAuthorisedDeliverCsa,
          value: 'AUTHORISED_TO_DELIVER_CSA_SHIPMENT',
          filterValue: {
            value: '23'
          }
        },
      ]
    },
    {
      label: translatedTextsObject.bolNumber,
      type: 'textfield',
      name: 'bolNumber',
      operatorType: LIKE
    },    
    {
      label: translatedTextsObject.createdDate,
      type: 'daterange',
      name: 'createdDate',
      operatorType: BETWEEN
    },
    {
      label: translatedTextsObject.error,
      type: 'checkbox',
      name: 'errorDesc',
      operatorType: IN,
      options: [
        {
          label: translatedTextsObject.filterErrorDescEdifact,
          value: 'EDIFACT conformance check error',
          filterValue: {
            value: 'EDIFACT conformance check error'
          }
        },
      ]
    }
  ]

  function getStatusDescription(statusCode) {
    if (statusLookup[statusCode] != null) {
      return statusLookup[statusCode];
    }
    return statusCode;
  }

  function handleCloneArrivalCert(rowData) {
    createRecord.execute(
      ArrivalCertApiUrls.CLONE,
      rowData,
      (res) =>
        history.push({
          pathname: pathMap.ACI_HIGHWAY_INBOND_ARRIVAL_ADD_VIEW,
          state: res
        }),
      (error) => {
        console.error(error)
        showNotification('error', translatedTextsObject.cloneErrorMessage)
      }
    )
  }

  function handleDeleteArrivalCerts() {
    if (!_.isEmpty(alertDialog.arrivalCerts)) {
      deleteRecord.execute(
        ArrivalCertApiUrls.DELETE_ALL,
        alertDialog.arrivalCerts,
        (data) => {
          const results = Array.isArray(data) ? data : []
          const failedRecords = results.filter(
            (record) => !_.isEmpty(record?.errorMessages)
          )

          if (_.isEmpty(failedRecords)) {
            showNotification('success', translatedTextsObject.deleteSuccessMessage)
          } else {
            const errorMessages = failedRecords.map(
              (record) =>
                `${record.ccn ? record.ccn + ': ' : ''}${record.errorMessages.join(', ')}`
            )

            if (failedRecords.length < results.length) {
              errorMessages.unshift(
                translate(Namespace.ARRIVAL_CERT, ArrivalCertKeys.DELETE_PARTIAL_MESSAGE, {
                  deletedCount: results.length - failedRecords.length,
                  totalCount: results.length
                })
              )
            }

            showNotification('error', errorMessages)
          }

          setAlertDialog({ open: false, arrivalCerts: [] })

          if (tableRef.current?.performRefresh) {
            tableRef.current.performRefresh()
          }
        },
        (error) => console.error(error),
        () => setAlertDialog({ open: false, arrivalCerts: [] })
      )
    }
  }

    async function submitAll(rows) {
      if (rows.length > 0) {
        tableRef.current.setLoading(true)

      let fileForUserDetails = FileForUserGetUserDetails();
      if (fileForUserDetails != null && fileForUserDetails != undefined) {
        rows.forEach((rowData) => {
          rowData.fileForUserId = fileForUserDetails.fileForUserId;
          rowData.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
          rowData.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
        });
      }

      const normalizedRows = rows.map(row => ({
        ...row,
        businessNumber: row.businessNumber ?? "" // Normalize businessNumber
      }))

      securedSendRequest.execute('POST',
        ArrivalCertApiUrls.SUBMIT_ALL,
        normalizedRows,
        (response) => {
          const data = response.data
          var errorMessages = []
          var errorFlag = false

          if (Array.isArray(data)) {
            for (var key in data) {
              var obj = data[key]
              if (obj != null && obj.errorMessages != null && obj.errorMessages.length > 0) {
                errorMessages.push(...obj.errorMessages)
                errorFlag = true
              }
            }
          } else if (data != null && data.errorMessages != null && data.errorMessages.length > 0) {
            errorMessages.push(...data.errorMessages)
            errorFlag = true
          }

          if (errorFlag) {
            showNotification('error', errorMessages)
          } else {
            showNotification('success', translatedTextsObject.submitSuccessMessage)
          }
          tableRef.current.performRefresh()
        },
        (error) => {
          if (error.response && error.response.data && error.response.data.errorMessages) {
            showNotification('error', error.response.data.errorMessages)
          } else {
            showNotification('error', translatedTextsObject.submitAllFailedMessage)
          }
          console.log(error)
        },
        () => tableRef.current.setLoading(false)
      )
    }
  }

  async function submitAllAsModify(rows) {
    if (rows.length > 0) {
      tableRef.current.setLoading(true)
      let fileForUserDetails = FileForUserGetUserDetails();
      if (fileForUserDetails != null && fileForUserDetails != undefined) {
        rows.forEach((rowData) => {
          rowData.fileForUserId = fileForUserDetails.fileForUserId;
          rowData.fileForUserLoginId = fileForUserDetails.fileForUserLoginId;
          rowData.fileForUserPartyId = fileForUserDetails.fileForUserPartyId;
        });
      }
      const updatedRows = rows.map(row => ({
        ...row,
        messageFunction: "4", // Setting messageFunction to modify
        businessNumber: row.businessNumber ?? "" // Normalize businessNumber
      }));
      securedSendRequest.execute('POST',
        ArrivalCertApiUrls.SUBMIT_ALL,
        updatedRows,
        (response) => {
          const data = response.data
          var errorMessages = []
          var errorFlag = false

          if (Array.isArray(data)) {
            for (var key in data) {
              var obj = data[key]
              if (obj != null && obj.errorMessages != null && obj.errorMessages.length > 0) {
                errorMessages.push(...obj.errorMessages)
                errorFlag = true
              }
            }
          } else if (data != null && data.errorMessages != null && data.errorMessages.length > 0) {
            errorMessages.push(...data.errorMessages)
            errorFlag = true
          }

          if (errorFlag) {
            showNotification('error', errorMessages)
          } else {
            showNotification('success', translatedTextsObject.submitSuccessMessage)
          }
          tableRef.current.performRefresh()
        },
        (error) => {
          if (error.response && error.response.data && error.response.data.errorMessages) {
            showNotification('error', error.response.data.errorMessages)
          } else {
            showNotification('error', translatedTextsObject.submitAllFailedMessage)
          }
          console.log(error)
        },
        () => tableRef.current.setLoading(false)
      )
    }
  }

  return (
    <>
      <Table
        actions={[
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'upload']} />,
              onClick: () => setUploadCSVDialog({ open: true, tableRef: tableRef })
            },
            label: translatedTextsObject.uploadButton
          },
          {
            buttonProps: {
              color: 'primary',
              size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => history.push(pathMap.ACI_HIGHWAY_INBOND_ARRIVAL_ADD_VIEW)
            },
            label: translatedTextsObject.createButton
          }
        ]}
        columns={columns}
        compact
        exportData={{ url: ArrivalCertApiUrls.EXPORT }}
        fetch={{ url: ArrivalCertApiUrls.GET }}
        fetchFilters={[
          { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() }
        ]}
        filters={filters}
        onRowClick={(rowData) => {
          history.push(
            generatePath(
              rowData.status === '1008'
                ? pathMap.ACI_HIGHWAY_INBOND_ARRIVAL_DETAILS_VIEW
                : pathMap.ACI_HIGHWAY_INBOND_ARRIVAL_EDIT_VIEW,
              { id: rowData.id }
            )
          )
        }
        }
        showNotification={showNotification}
        sortConfig={{
          type: 'column',
          defaultField: 'createdDate',
          defaultDirection: 'DESC'
        }}
        persistSettings
        tableRef={tableRef}
        checkboxSelection
        rowActions={[
          {
            disabled: (rowData) => rowData.status === '1008',
            tooltip: (rowData) => rowData.status === '1008' ? translatedTextsObject.editTooltipDisabled : translatedTextsObject.editButton,
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: translatedTextsObject.editButton,
            onClick: (rowData) =>
              history.push(
                generatePath(pathMap.ACI_HIGHWAY_INBOND_ARRIVAL_EDIT_VIEW, { id: rowData.id })
              )
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'copy']} />,
            label: translatedTextsObject.cloneButton,
            onClick: handleCloneArrivalCert
          }
        ]}
        selectActions={[
          {
            // disabled: (rows) => rows.length > 500,
            icon: <FontAwesomeIcon icon={['fal', 'arrow-alt-right']} />,
            label: translatedTextsObject.submitAllButton,
            onClick: (rows) => {
              return submitAll(rows);
            },
            disabled: (rows) => DisableSubmitButton(rows),
            tooltip: (rows) => DisableSubmitButton(rows) ? translatedTextsObject.submitMultipleRecords : null
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'arrow-alt-right']} />,
            label: translatedTextsObject.submitAsModifyButton,
            onClick: (rows) => {
              return submitAllAsModify(rows);
            },
            disabled: (rows) => DisableSubmitAsModifyButton(rows),
            tooltip: (rows) => DisableSubmitAsModifyButton(rows) ? translatedTextsObject.submitAsModify : null
          },
          {
            disabled: DisableDeleteButtonByStatus,
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            label: translatedTextsObject.deleteButton,
            onClick: (rows) => setAlertDialog({ open: true, arrivalCerts: rows }),
            tooltip: (rows) =>
              DisableDeleteButtonByStatus(rows)
                ? translatedTextsObject.deleteMultipleRecords
                : null
          }
        ]}
      />
      <ArrivalCertUploadDialog
        open={uploadCSVDialog}
        onClose={() => setUploadCSVDialog(false)}
        showNotification={showNotification}
      />
      <AlertDialog
        cancelLabel={translatedTextsObject.deleteConfirmNo}
        confirmLabel={translatedTextsObject.deleteConfirmYes}
        open={alertDialog.open}
        onClose={() => setAlertDialog({ open: false, arrivalCerts: [] })}
        onCancel={() => setAlertDialog({ open: false, arrivalCerts: [] })}
        onConfirm={handleDeleteArrivalCerts}
        title={translatedTextsObject.deleteButton}
      >
        {translatedTextsObject.deleteConfirmMessage}
      </AlertDialog>
    </>
  )
}

export default TablePage
